import CardProduct from "components/global/card-product/card-product"
import { Slider, Button } from "components/anti"
import { useState } from "react"
import BlankStateWishlist from "../wishlist/blank-state"

const WishComp = ({ data, locale, locales, isBlank }) => {
  //States
  const [state, setState] = useState({
    isBlank: isBlank,
    wishlist: data,
    locale,
  })

  //Functions
  const handleCallbackWishlist = (id) => {
    let newState = state.wishlist.filter((item) => item.id !== id)
    if (newState.length == 0)
      return setState((prev) => ({
        ...prev,
        wishlist: newState,
        isBlank: true,
      }))
    else return setState((prev) => ({ ...prev, wishlist: newState }))
  }

  return (
    <>
      {state.wishlist?.length > 0 ? (
        <div className="sc-wishlist-cart container">
          <div className={`general-title-wrapper pt-3 pb-1 row`}>
            <div className="col-6">
              <h1>{locale === "id" ? "Wishlist Saya" : "My Wishlist"}</h1>
            </div>
            <div className="col-6">
              <Button
                variant="link"
                link="/wishlist"
                className="hover-underline inverse see-all-wish"
              >
                {locale === "id" ? "LIHAT SEMUA" : "SEE ALL"}
              </Button>
            </div>
          </div>
          <hr />
          <div className="wishlist-content">
            {state.isBlank ? (
              <BlankStateWishlist />
            ) : (
              <Slider
                arrowsMdDown={true}
                arrowsSmDown={true}
                showInitial={6.2}
                showXxlDown={6.2}
                showXlDown={4.2}
                showLgDown={2.2}
                showMdDown={2.2}
                showSmDown={2.2}
                className="wishlist-cart-slider"
              >
                {state.wishlist?.slice(0, 18).map((item, i) => (
                  <CardProduct
                    key={i}
                    timesIcon
                    noHeartIcon
                    noCategory
                    {...item}
                    callback={handleCallbackWishlist}
                    imgAlt={`wishlist-${i}`}
                    listName={"Wishlist"}
                    index={i + 1}
                  />
                ))}
              </Slider>
            )}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default WishComp
